<button mat-button class="ribbon-button-padding" type="button" (click)="onClick()">
    <mat-icon class="save-icon" [class]="theme.myIconColor">delete</mat-icon> 
    <span>Delete</span> 
</button>
